export default "__VITE_ASSET__DWT23gSE__"